export default __webpack_public_path__ + "static/media/warning_noti.f96f361b.svg";